import React from 'react';
import { Stack, Text } from '@mantine/core';

import { PopupEventVendorDetailsUpcoming } from '../types';
import MealPrepFactor from './MealPrepFactor';

type PopupUpcomingFactorsProps = {
  event: PopupEventVendorDetailsUpcoming;
};

const PopupUpcomingFactors: React.FC<PopupUpcomingFactorsProps> = ({ event }) => {
  if (!event.mealPrep?.factors?.length) {
    return null;
  }

  return (
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      {event.mealPrep.factors.map((factor) => (
        <MealPrepFactor factor={factor} event={event} />
      ))}
      <Text fz="sm" fs="italic" c="dimmed">
        Meal Prep data last updated: Less than 48 hours ago
      </Text>
    </Stack>
  );
};

export default PopupUpcomingFactors;
